/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { seguridad } from '../../conexiones';
import ITipoCuentaBancaria from './entidades/tipoCuentaBancaria';

export default class ModeloTipoCuentaBancaria {
    public consultarTipoCuentaBancaria() {
        return manejadorRest<IRespuesta<ITipoCuentaBancaria>>(() =>
        seguridad.get('TipoCuentaBancaria/ConsultarListaTipoCuentaBancaria')
        );
    }
    public crearTipoCuentaBancaria(tipoCuentaBancaria: ITipoCuentaBancaria) {
        return manejadorRest<IRespuesta<ITipoCuentaBancaria>>(() =>
        seguridad.post('TipoCuentaBancaria/GuardarTipoCuentaBancaria', tipoCuentaBancaria)
        );
    }
    public editarTipoCuentaBancaria(tipoCuentaBancaria: ITipoCuentaBancaria) {
        return manejadorRest<IRespuesta<ITipoCuentaBancaria>>(() =>
        seguridad.put('TipoCuentaBancaria/EditarTipoCuentaBancaria', tipoCuentaBancaria)
        );
    }
    public eliminarTipoCuentaBancaria(tipoCuentaBancaria: ITipoCuentaBancaria) {
        return manejadorRest<IRespuesta<ITipoCuentaBancaria>>(() =>
        seguridad.delete('TipoCuentaBancaria/EliminarTipoCuentaBancaria', tipoCuentaBancaria)
        );
    }
}
